import { render } from "./ActivityHeader.vue?vue&type=template&id=535093f4&scoped=true"
import script from "./ActivityHeader.vue?vue&type=script&lang=js"
export * from "./ActivityHeader.vue?vue&type=script&lang=js"

import "./ActivityHeader.vue?vue&type=style&index=0&id=535093f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535093f4"]])

export default __exports__